import * as de from './de.json';
import * as en from './en.json';
import * as fr from './fr.json';
import * as it from './it.json';
import * as nl from './nl.json';
import * as es from './es.json';
import * as cs from './cs.json';
import * as sk from './sk.json';
import * as da from './da.json';
import * as pl from './pl.json';

export const routeLoaderMap: Record<string, () => Promise<unknown>> = {
  de: () => new Promise(res => res(de)),
  en: () => new Promise(res => res(en)),
  fr: () => new Promise(res => res(fr)),
  it: () => new Promise(res => res(it)),
  nl: () => new Promise(res => res(nl)),
  es: () => new Promise(res => res(es)),
  cs: () => new Promise(res => res(cs)),
  sk: () => new Promise(res => res(sk)),
  da: () => new Promise(res => res(da)),
  pl: () => new Promise(res => res(pl))
};
